import React from "react";
import { useTranslation } from "react-i18next";
import type {
  AdminHotelMetricRow,
  AdminTabMetricColumnDef,
} from "../../types/adminHotelMetricTable";
import { AdminHotelsMetricTable } from "../shared/AdminHotelsMetricTable";

type AdminOffersHotelsTableProps = {
  rows: AdminHotelMetricRow[];
  columns: AdminTabMetricColumnDef[];
  loading?: boolean;
};

export const AdminOffersHotelsTable = ({
  rows,
  columns,
  loading = false,
}: AdminOffersHotelsTableProps): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <AdminHotelsMetricTable
      tab="offers"
      columns={columns}
      rows={rows}
      loading={loading}
      emptyMessage={t(
        "analytics.admin.offers.table.empty",
        "No offers data for the selected period.",
      )}
    />
  );
};
